// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 2.5H14.5',
  'M2.5 2.5V8.5C2.5 9.6 3.4 10.5 4.5 10.5H11.5C12.6 10.5 13.5 9.6 13.5 8.5V2.5',
  'M4.75 14.5L8 10.5L11.25 14.5',
];
